export default __webpack_public_path__ + "c4754cdeaa3864af1665583cd251949b.svg";